var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 41,
    viewBox: "0 0 31 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 36.2794C11.1107 36.2794 11.2167 36.3233 11.2948 36.4015C11.3729 36.4796 11.4168 36.5856 11.4168 36.6961C11.4168 36.8066 11.3729 36.9126 11.2948 36.9907C11.2167 37.0688 11.1107 37.1127 11.0002 37.1127C10.8897 37.1127 10.7837 37.0688 10.7055 36.9907C10.6274 36.9126 10.5835 36.8066 10.5835 36.6961C10.5835 36.5856 10.6274 36.4796 10.7055 36.4015C10.7837 36.3233 10.8897 36.2794 11.0002 36.2794Z",
    stroke: "#1D2733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 1.69617H3.49984C1.65889 1.69617 0.166504 3.18855 0.166504 5.0295V36.6962C0.166504 38.5371 1.65889 40.0295 3.49984 40.0295H18.4998C20.3408 40.0295 21.8332 38.5371 21.8332 36.6962V5.0295C21.8332 3.18855 20.3408 1.69617 18.4998 1.69617Z",
    stroke: "#1D2733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8332 33.3628H0.166504",
    stroke: "#1D2733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8332 8.36279H0.166504",
    stroke: "#1D2733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.02942H13.5",
    stroke: "#1D2733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 40,
    fill: "white",
    transform: "translate(0 0.862793)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutlined);
export default __webpack_public_path__ + "static/media/phone-outlined.5cc59e6c.svg";
export { ForwardRef as ReactComponent };